import { mainStore } from 'enasops/stores'
import { axiosHost } from 'src/plugins/api/axios'

/**
 * 获取当前环境下对应的文件服务器基址
 * @param path 
 * @param field 
 * @returns 
 */
export const getFileUrl = (path?: string, field?: string) => {
  if (!path) return
  return `${mainStore.baseConfig.FileDomain || axiosHost(field || 'img')}${path}`
}